export default __webpack_public_path__ + "static/media/banner-section_dynamic.e70b2b3d.svg";